var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegram = function SvgTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#61A8DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2006 11.3398L7.31208 21.0382C6.50612 21.3528 6.55551 22.5088 7.38487 22.7541L13.7086 24.6217L16.0693 32.111C16.3163 32.8936 17.3077 33.131 17.8814 32.5443L21.1512 29.2052L27.5668 33.9153C28.352 34.4916 29.4699 34.0635 29.6701 33.1102L33.9191 12.794C34.1271 11.8 33.1479 10.9698 32.2006 11.3398M29.0808 15.848L17.5201 26.0707C17.4048 26.173 17.3312 26.3142 17.3138 26.4667L16.8693 30.4229C16.8545 30.5529 16.6743 30.5702 16.6353 30.4454L14.8041 24.5446C14.72 24.2751 14.8292 23.9821 15.0701 23.8331L28.7221 15.3662C29.0358 15.1712 29.3573 15.6028 29.0808 15.848",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export default ForwardRef;